export const ADD_USER = 'add_user';
export const ADD_USER_SUCCESSFUL = 'add_user_successfull';
export const ADD_USER_ERROR = 'add_user_error';

export const GET_NEW_COGNITO_USER = 'get_cognito_user';
export const GET_NEW_COGNITO_USER_FAILED = 'get_cognito_user_failed';
export const GET_NEW_COGNITO_SUCCESSFUL = 'get_cognito_user_successful';

export const UPDATE_COGNITO_USER = 'update_cognito_user';
export const UPDATE_COGNITO_USER_SUCCESSFUL = "update_cognito_user_successful";
export const UPDATE_COGNITO_USER_FAILED = "update_cognito_user_failed";

export const DELETE_COGNITO_USER = "delete_cognito_user";
export const DELETE_COGNITO_USER_SUCCESSFUL = "delete_cognito_user_successful";
export const DELETE_COGNITO_USER_FAILED = "delete_cognito_user_failed";
